<template>
  <div>
    <el-tabs v-model="activeName" style="background-color: white;padding: 20px">
      <el-tab-pane label="笔记发布" name="first">

        <el-form :model="formData" :rules="rules" ref="formData" label-width="100px" class="demo-ruleForm">

          <el-form-item label="标题:" prop="title">
            <el-input v-model="formData.title" placeholder="请输入内容" style="width: 90%"></el-input>
          </el-form-item>

          <el-form-item label="图片" prop="image" style="margin: 20px 50px">
            <div style="display: flex">
              <!--          111-->
              <el-upload

                v-model="formData.image1"
                class="avatar-uploader"
                name="image"
                :show-file-list="false"
                :action="base_url_image"
                :on-success=" uploadAvatar1"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="formData.image1" :src="formData.image1" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <!--          222-->
              <el-upload
                v-model="formData.image2"
                class="avatar-uploader"
                name="image"
                :show-file-list="false"
                :action="base_url_image"
                :on-success=" uploadAvatar2"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="formData.image2" :src="formData.image2" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <!--          333-->
              <el-upload
                v-model="formData.image3"
                class="avatar-uploader"
                name="image"
                :show-file-list="false"
                :action="base_url_image"
                :on-success=" uploadAvatar3"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="formData.image3" :src="formData.image3" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>

          </el-form-item>
          <el-form-item label="内容:" prop="content" type="textarea">
            <el-input v-model="formData.content" placeholder="请输入内容" style="width: 90%"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('formData')">发布</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="笔记管理" name="second">
        <!--      展示-->
        <el-table
          :data="tableData"
          border
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          style="width: 100%">
          <el-table-column
            prop="count"
            label="编号"
            width="60">
          </el-table-column>
          <el-table-column
            label="图片"
            width="85">
            <template slot-scope="scope">
              <img v-if="scope.row.image1" :src="scope.row.image1" height="60px" width="60px"
                   style="border-radius: 50%">
              <span v-else>空</span>
            </template>

          </el-table-column>

          <el-table-column
            label="图片"
            width="85">
            <template slot-scope="scope">
              <img v-if="scope.row.image2" :src="scope.row.image2" height="60px" width="60px"
                   style="border-radius: 50%">
              <span v-else>空</span>
            </template>
          </el-table-column>

          <el-table-column
            label="图片"
            width="85">
            <template slot-scope="scope">
              <img v-if="scope.row.image3" :src="scope.row.image3" height="60px" width="60px"
                   style="border-radius: 50%">
              <span v-else>空</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="title"
            label="标题"
            width="120">
          </el-table-column>

          <el-table-column
            prop="content"
            label="介绍"
            width="400">
          </el-table-column>

          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "EssayManager",
  data() {

    return {
      base_url_image: base_url + '/uploadImage',
      activeName: 'first',
      id: null,
      picList: [],
      dialogVisible: false,
      tableData: [
        {
          count: null,
          title: null,
          content: null,
          image1: null,
          image2: null,
          image3: null,
        }
      ],
      formData: {
        adminId: null,
        title: null,
        content: null,
        image1: null,
        image2: null,
        image3: null,
      },

      rules: {
        //图片
        // image:[
        //   {required: true, validator: checkPice, trigger: 'blur'}
        // ],
        //标题
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        //内容
        content: [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],

      },
    };
  },
  methods: {
    // 删除
    handleDelete(index, row) {
      let that = this;
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/notes/deleteNotes',
          method: 'post',
          params: {
            notesId: row.id,
            adminInfo: that.adminInfo
          }
        }).then(response => {
          if (response.data.flag) {
            this.$notify.success({
              title: '删除',
              duration: 2000,
              message: '删除成功！'
            });
            that.AdminUserEssay();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'success',
          message: '已取消'
        })
      })

    },

    //发布
    submitForm(formData) {
      let that = this;
      // console.log(this.formData)
      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将添加用户信息，是否继续?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            request({
              url: '/notes/addNotes',
              method: 'post',
              params: {
                adminInfo: that.adminInfo,
                notes: this.formData,
              }
            }).then(response => {
              if (response.data.flag) {
                this.$notify.success({
                  title: '添加',
                  duration: 2000,
                  message: response.data.message
                });
                this.AdminUserEssay();
              }else{
                this.$notify.error({
                  title: '笔记',
                  duration: 2000,
                  message: '参数有误'
                })
              }
            }).catch(e => {
              this.$notify.error({
                title: '笔记',
                duration: 2000,
                message: '添加失败'
              });
            })
          }).catch(() => {
            this.$message({
              type: 'success',
              message: '已取消',
            });
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      });

    },

    //处理头像之前
    beforeAvatarUpload(file) {
      // console.log(file);
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },

    //添加处理头像成功
    uploadAvatar1(result) {
      // console.log(result)
      if (result.flag) {
        this.formData.image1 = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }

    },
    uploadAvatar2(result) {
      // console.log(result)
      if (result.flag) {
        this.formData.image2 = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }

    },
    uploadAvatar3(result) {
      // console.log(result)
      if (result.flag) {
        this.formData.image3 = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 6000,
          message: result.message
        });
      }

    },
    // 显示
    AdminUserEssay() {
      let that = this;
      request({
        url: '/notes/getNotes',
        method: 'get',
      }).then(response => {
        // console.log(response)
        if (response.data.data == null) {

        } else {
          let count = 1;
          response.data.data.forEach(value => {
            value.count = count++;
            if (value.image1 == null) {

            } else {
              value.image1 = base_url + '/getImage/' + value.image1;
            }

            if (value.image2 == null) {

            } else {
              value.image2 = base_url + '/getImage/' + value.image2;
            }
            if (value.image3 == null) {

            } else {
              value.image3 = base_url + '/getImage/' + value.image3;
            }
          })
        }

        that.tableData = response.data.data;
      })
    },
    //清空上传组件
    /*  emptyUpload(){
        const mainImg = this.$refs.upload
        if (mainImg) {
          if (mainImg.length) {
            mainImg.forEach(item => {
              item.clearFiles()
            })
          } else {
            this.$refs.upload.clearFiles()
          }
        }

        },*/
  },
  mounted() {
    var item = window.sessionStorage.getItem('adminInfo');
    let data = JSON.parse(item);
    this.id = data.id
    this.formData.adminId = data.id;
    this.adminInfo = data;
    this.AdminUserEssay();
  }


}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/EssayManager.vue